module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'pro'
      }
    }
  }, [_vm._v("我的商品")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("维护商品")])], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "基本信息"
    }
  }, [_c('el-form', {
    ref: "Product",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.Product.Data,
      "rules": _vm.Productrules,
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品编码",
      "prop": "SKU"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品编码"
    },
    model: {
      value: (_vm.Product.Data.SKU),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "SKU", $$v)
      },
      expression: "Product.Data.SKU"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.Product.Data.Name),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "Name", $$v)
      },
      expression: "Product.Data.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品分类"
    }
  }, [_c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "clearable": "",
      "options": _vm.Cate
    },
    model: {
      value: (_vm.selectedCate),
      callback: function($$v) {
        _vm.selectedCate = $$v
      },
      expression: "selectedCate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品规格/型号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品规格/型号"
    },
    model: {
      value: (_vm.Product.Data.Model),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "Model", $$v)
      },
      expression: "Product.Data.Model"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入品牌"
    },
    model: {
      value: (_vm.Product.Data.Brand),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "Brand", $$v)
      },
      expression: "Product.Data.Brand"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "加盟商"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入加盟商"
    },
    model: {
      value: (_vm.Product.Data.franchise),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "franchise", $$v)
      },
      expression: "Product.Data.franchise"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品价格(元)",
      "prop": "Price"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品价格"
    },
    model: {
      value: (_vm.Product.Data.Price),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "Price", $$v)
      },
      expression: "Product.Data.Price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品条形码",
      "prop": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品条形码"
    },
    model: {
      value: (_vm.Product.Data.UPC),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "UPC", $$v)
      },
      expression: "Product.Data.UPC"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品图片",
      "label-for": "fileInputMulti",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.getFile($event)
      }
    }
  })])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品简介"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品简介",
      "maxlength": "25"
    },
    model: {
      value: (_vm.Product.Data.Description),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "Description", $$v)
      },
      expression: "Product.Data.Description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图文详情"
    }
  }, [_c('vue-editor', {
    attrs: {
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.Product.Data.DescriptionHtml),
      callback: function($$v) {
        _vm.$set(_vm.Product.Data, "DescriptionHtml", $$v)
      },
      expression: "Product.Data.DescriptionHtml"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "自定义参数配置"
    }
  }, [_c('el-form', [_vm._l((_vm.CustomParams), function(item, key, index) {
    return _c('el-row', {
      key: key
    }, [_c('el-col', [_c('el-form-item', [_c('el-input', {
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "type": "text",
        "placeholder": item.key
      },
      model: {
        value: (item.key),
        callback: function($$v) {
          _vm.$set(item, "key", $$v)
        },
        expression: "item.key"
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "40%",
        "margin-left": "3%"
      },
      attrs: {
        "type": "text",
        "placeholder": item.value
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "m-0",
      staticStyle: {
        "margin-left": "3%",
        "background-color": "#ffc107"
      },
      attrs: {
        "variant": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.removeConf(index)
        }
      }
    }, [_vm._v(" 删除")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "#fff"
    },
    attrs: {
      "size": "small",
      "type": "submit",
      "variant": "warning"
    },
    on: {
      "click": _vm.addConfig
    }
  }, [_vm._v("新增")])], 1)], 2)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "取货模式"
    }
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, _vm._l((_vm.Product.Data.FetchParams), function(item, key, index) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": _vm.FetchModel(key),
        "label-for": "basicSelect",
        "label-cols": 3,
        "horizontal": true
      }
    }, [_c('el-radio-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchSpeed'),
        expression: "key === 'FetchSpeed'"
      }],
      model: {
        value: (_vm.Product.Data.FetchParams.FetchSpeed),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "FetchSpeed", $$v)
        },
        expression: "Product.Data.FetchParams.FetchSpeed"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("高速")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("常速")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("低速")])], 1), _vm._v(" "), _c('el-radio-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchStyle'),
        expression: "key === 'FetchStyle'"
      }],
      model: {
        value: (_vm.Product.Data.FetchParams.FetchStyle),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "FetchStyle", $$v)
        },
        expression: "Product.Data.FetchParams.FetchStyle"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "low"
      }
    }, [_vm._v("低位")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "mid"
      }
    }, [_vm._v("中位")])], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchDelay'),
        expression: "key === 'FetchDelay'"
      }]
    }, [_c('el-input-number', {
      attrs: {
        "step": 10,
        "controls-position": "right"
      },
      model: {
        value: (_vm.Product.Data.FetchParams.FetchDelay),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "FetchDelay", $$v)
        },
        expression: "Product.Data.FetchParams.FetchDelay"
      }
    }), _vm._v(" x10 = " + _vm._s(_vm.Product.Data.FetchParams.FetchDelay * 10) + "毫秒")], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchPreDelay'),
        expression: "key === 'FetchPreDelay'"
      }]
    }, [_c('el-input-number', {
      attrs: {
        "step": 10,
        "controls-position": "right"
      },
      model: {
        value: (_vm.Product.Data.FetchParams.FetchPreDelay),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "FetchPreDelay", $$v)
        },
        expression: "Product.Data.FetchParams.FetchPreDelay"
      }
    }), _vm._v(" x10 = " + _vm._s(_vm.Product.Data.FetchParams.FetchPreDelay * 10) + "毫秒")], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchDuration'),
        expression: "key === 'FetchDuration'"
      }]
    }, [_c('el-input-number', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'FetchDuration'),
        expression: "key === 'FetchDuration'"
      }],
      attrs: {
        "step": 10,
        "controls-position": "right"
      },
      model: {
        value: (_vm.Product.Data.FetchParams.FetchDuration),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "FetchDuration", $$v)
        },
        expression: "Product.Data.FetchParams.FetchDuration"
      }
    }), _vm._v(" x5 = " + _vm._s(_vm.Product.Data.FetchParams.FetchDuration * 5) + "毫秒")], 1), _vm._v(" "), _c('el-radio-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'TrayType'),
        expression: "key === 'TrayType'"
      }],
      model: {
        value: (_vm.Product.Data.FetchParams.TrayType),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "TrayType", $$v)
        },
        expression: "Product.Data.FetchParams.TrayType"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "raw"
      }
    }, [_vm._v("无托盘")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "tray"
      }
    }, [_vm._v("有托盘")])], 1), _vm._v(" "), _c('el-radio-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key === 'TrayCount'),
        expression: "key === 'TrayCount'"
      }],
      model: {
        value: (_vm.Product.Data.FetchParams.TrayCount),
        callback: function($$v) {
          _vm.$set(_vm.Product.Data.FetchParams, "TrayCount", $$v)
        },
        expression: "Product.Data.FetchParams.TrayCount"
      }
    }, _vm._l(([0, 1, 2, 3, 4]), function(item) {
      return _c('el-radio', {
        key: item,
        attrs: {
          "label": item
        }
      }, [_vm._v(_vm._s(item))])
    }), 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "#fff"
    },
    attrs: {
      "type": "submit",
      "size": "small",
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" 保存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#f64846",
      "color": "#fff"
    },
    attrs: {
      "type": "reset",
      "size": "small",
      "variant": "danger"
    },
    on: {
      "click": _vm.cancleBack
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" 撤销并返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4077c908!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/product/editPro.vue
// module id = 1055
// module chunks = 2